import { FaIcon } from '@/lib/fa'
import React from 'react'

const OptionField = ({
  isSelected,
  onClick,
  label,
  iconRegular,
  iconSolid,
}) => {
  return (
    <div
      className={`tw-flex tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded tw-border-2 tw-p-2 ${isSelected ? 'tw-border-primary tw-bg-secondary' : 'tw-border-base-300'} `}
      onClick={onClick}
    >
      <FaIcon
        icon={isSelected ? iconSolid : iconRegular}
        className={`tw-h-3 tw-w-3 ${isSelected ? 'tw-text-primary' : 'tw-text-content-base'}`}
      />
      <span
        className={`tw-text-sm tw-font-medium ${isSelected ? 'tw-text-primary' : 'tw-text-content-base'}`}
      >
        {label}
      </span>
    </div>
  )
}

export default OptionField
